import { useSelector } from "react-redux";
import UserProfile from "./components/UserProfile";

const Profile: React.FC = () => {
    const user = useSelector((state: any) => state.auth.authState.authUser?.user);
    const userState = useSelector((state: any) => state.users.fetchUsersState);

    let matchedUserData = null;
    
    if (userState?.users) {
        if (Array.isArray(userState.users)) {
            matchedUserData = userState.users.find((item: any) => item.id === user?.id);
        } else {
            matchedUserData = userState.users;
        }
    }

    return (
        <>
            {matchedUserData ? (
                <UserProfile userData={matchedUserData} />
            ) : (
                <p>Loading user profile...</p>
            )}
        </>
    );
};
export default Profile;